import { render } from "./BillingChart.vue?vue&type=template&id=acf52788"
import script from "./BillingChart.vue?vue&type=script&lang=js"
export * from "./BillingChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__